import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { DocumentList } from './document-list.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentListService {
  constructor(private http: HttpClient) {}

  getDocumentList(identityType: string, identityNo: string, lang: string): Observable<DocumentList[]> {
    const url = `${
      environment.endpoint.epolicyAPI
    }/documents/${identityType}?identityNo=${identityNo}&language=${lang}`;

    return this.http.get<DocumentList[]>(url).pipe(
      map(
        (documentList: DocumentList[]): DocumentList[] => {
          let count = 0;
          documentList.forEach((d: DocumentList) => {
            count = count + d.documentDetail.length;
          });
          return count ? documentList : null;
        }
      )
    );
  }
}
